import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { custom, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import UserDefinedTab from './tabs/UserDefinedTab';
import { IM, WM, RECORD_TYPE, EMPTY_GUID, CrateProfileRoutes } from "../../../const/constants";
import ValidationSummary from 'devextreme-react/validation-summary';
import { MESSAGES } from "../../../common/Messages";
import routes from "../../../assets/apiRoutes.json";
import PrimaryTab from "./tabs/PrimaryTab";
import { locationTypes, optionsYesNo, status } from "../../../const/Lookup";
import { GetFormatedDateWithTime, loadLookupFromStaticDataSource } from "../../../common/Utils";
import { LocationStatus, LocationTypes as LocType, Options } from "../../../enum/Enum";
import AdditionalTab from "./tabs/AdditionalTab";
import ContentsDetailTab from "./tabs/ContentsDetailTab";
var skipDataLoading = false;
function LocationDataEntryForm(props) {
    const [dialogVisible, setDialogVisible] = useState(false);

    const closeDialog = () => {
        setDialogVisible(false);
    };
    const initialFormFields = {
        RowId: '00000000-0000-0000-0000-000000000000',
        KeySequence: 1,
        CrateNumber: null,
        Description: null,
        Dimensions: null,
        Height: null,
        Width: null,
        Depth: null,
        Cube: null,
        GrossWeightQuantity: null,
        NetWeightQuantity: null,
        ReceivedDate: null,
        ShippedDate: null,
        RecordNumber: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        RecordType: props.recordType || null, // 'P' on the Crate Defaults route; set by the API otherwise
        Status: null,
        UserdefinedCode1: null,
        UserdefinedCode2: null,
        UserdefinedCode3: null,
        UserdefinedCode4: null,
        UserdefinedCode5: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedComment: null,
        Module: props.Module,
        RProfile: null,
        RWarehouse: null,
        RLocation: null,
        ROwner: null,
        TareWeightQuantity: null,
        SSCCNumber : null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };

    // Single source of truth for the profile-defaults route (Crate Profile -> Crate Defaults).
    // Read from the live URL, not props: onFormLoad and the widgets' onValueChanged both run
    // closures captured before props were populated, so a props-derived value goes stale in exactly
    // the places that matter. formFieldsRef is the second source because an existing 'P' record
    // opened for edit carries the record type in state without recordType being in the URL.
    // Same shape as itemDataEntry/Form.js readProfileDefaults.
    const readProfileDefaults = () => {
        const params = new URLSearchParams(window.location.search);
        return {
            isProfileDefaults:
                params.get('recordType') === RECORD_TYPE.PROFILE_DEFAULTS
                || formFieldsRef.current?.RecordType === RECORD_TYPE.PROFILE_DEFAULTS,
            profileRowId: params.get('RProfile'),
            profileCode: params.get('profileCode'),
        };
    };

    const { isProfileDefaults } = readProfileDefaults();
    const hasSeededProfileDefaults = useRef(false);
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    useEffect(() => {
        if (formFields)
            formFieldsRef.current = formFields;
    }, [formFields])

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            await updateTransaction();
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            setLoadPanelVisible(true);
            let fields = formatDates();

            // The crate screen had no insert path until the Crate Profile screen needed one: a
            // profile with no 'P' template opens this form on the Add route with no key. Same split
            // the item screen uses - POST wm/Item/InsertItem vs PUT wm/Item/UpdateItem.
            const isInsert = !fields.RowId || fields.RowId === EMPTY_GUID;
            const response = isInsert
                ? await axios.post(`${window._env_.REACT_APP_APIS}/${routes.IM.InsertCrate}`, fields, {
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                })
                : await axios.put(`${window._env_.REACT_APP_APIS}/${routes.IM.UpdateCrate}`, fields, {
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    },
                });
            if (response.data.issuccess) {

                notify(
                    {
                        // CreateUpateApiResponse only carries a message on failure, so the wording is
                        // chosen here - and it has to follow the branch above, or a new crate reports
                        // itself as updated.
                        message: isInsert ? MESSAGES.CREATE_SUCCESS : MESSAGES.UPDATE_SUCCESS,
                        width: 300,
                    },
                    'success',
                    3000,
                );
                // An insert has no props.id - the Add route's URL never changes - so take the key
                // from the response, or Reset and the next Save would not find the record.
                var rowid = props.id || response.data.rowid;
                if (rowid != null && rowid != undefined && rowid != '' && rowid !== EMPTY_GUID) {
                    GetHeaderInfoById(rowid);
                }
            } else {
                const errorHtml = (response.data.message || "").replace(/\\r\\n|\r\n|\n/g, "<br/>");
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error(MESSAGES.ERROR_FORM_SUBMISSION, error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);
            setLoadPanelVisible(false);
        }
    };
    const formatDates = () => {
        let fields = formFields;
        fields.ReceivedDate = GetFormatedDateWithTime(formFields.ReceivedDate);
        fields.ShippedDate = GetFormatedDateWithTime(formFields.ShippedDate);

        fields.UserDefinedDate1 = GetFormatedDateWithTime(formFields.UserDefinedDate1);
        fields.UserDefinedDate2 = GetFormatedDateWithTime(formFields.UserDefinedDate2);
        fields.UserDefinedDate3 = GetFormatedDateWithTime(formFields.UserDefinedDate3);
        fields.UserDefinedDate4 = GetFormatedDateWithTime(formFields.UserDefinedDate4);
        fields.UserDefinedDate5 = GetFormatedDateWithTime(formFields.UserDefinedDate5);
        return fields;
    };
    const handleReset = () => {
        // props.id is null on the add route even after a save - the URL never changes - so fall back
        // to the key the insert response put in state, or Reset would discard the saved record.
        const savedRowId = formFields.RowId && formFields.RowId !== EMPTY_GUID ? formFields.RowId : null;
        var rowid = props.id || savedRowId;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableDisableControls();

            // The profile owns this record, so a reset must not clear its code or unlock the field.
            // Re-seeding after the blank works because SeedProfileDefaultsCrate uses a functional
            // update: React applies it to the result of the reset in the same batch.
            const { isProfileDefaults: isProfileDefaultsRoute, profileRowId } = readProfileDefaults();
            if (isProfileDefaultsRoute) {
                if (profileRowId) {
                    SeedProfileDefaultsCrate(profileRowId);
                }

                DisableProfileField();
            }
        }
    };
    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/${routes.IM.GetCrate}?rowId=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                // A record the query filters out comes back as a null body, so the RowId read has to
                // be guarded - without it this threw inside the promise with nothing to catch it.
                if (responseData && responseData.RowId) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                }
                else {
                    console.error(MESSAGES.FETCH_ERROR);
                }
            }).catch((error) => {
                console.error(MESSAGES.FETCH_ERROR, error);
            }).finally(() => {
                setTimeout(hideLoadPanel, 1000);
            });


        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const EnableDisableControls = () => {
    }
    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            EnableDisableControls();
        }
        // Keyed on props.id like itemDataEntry/Form.js: the route can hand the id over on a render
        // after the first, and an empty dependency list would never load it.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.id]);
    const goBack = () => {
        // A profile template was opened from the Crate Profile screen, so Back returns there rather
        // than to the crate listing - Delphi ends uWMD0063 with ab_ExitProgram back to uWMD0064.
        if (isProfileDefaults) {
            // Push the profile's Edit route explicitly rather than history.goBack(): the profile form
            // stays on its Create URL after a save (it only updates ROWID in state), so goBack()
            // would remount a blank Add Profile screen and the saved record would appear lost.
            // Take the key from the URL, which the Crate Profile screen stamps on both of its Crate
            // Defaults routes. formFields.RProfile is only a fallback - on the item screen the
            // equivalent field was observed holding the record's own rowid, which 404'd.
            const { profileRowId } = readProfileDefaults();
            const target = profileRowId || formFields.RProfile;
            history.push(target ? `${CrateProfileRoutes.Edit}?rowid=${target}` : CrateProfileRoutes.List);
            return;
        }

        if (props.Module === WM)
            history.push("/wm/codes/crate-data-entry");
        else if (props.Module === IM)
            history.push("/im/codes/crate-data-entry");
    };
    const handleFieldChange = useCallback((name, value, e, formRefs) => {

    }, []);
    // PrimaryTab keeps its own formRefs and hands them to onFormLoad - the formRefs declared in this
    // component never reach that tab's FormField. Stash the ones we are given so Reset can reach the
    // same widgets later, outside the form-load callback.
    const primaryFormRefs = useRef(null);

    const getFieldInstance = (name) => {
        const ref = primaryFormRefs.current?.current?.[name];
        return ref && typeof ref.instance === 'function' ? ref.instance() : null;
    };

    /**
     * uWMD0063.SetParameters: the profile owns this record, so its Profile field is locked for the
     * whole session (Delphi ab_EnableControl(edtP_PROFILE, False)).
     */
    const DisableProfileField = () => {
        const instance = getFieldInstance('RProfile');
        if (instance) instance.option('disabled', true);
    };

    // No ShowProfileCode equivalent here, deliberately. The item screen writes the profile CODE into
    // its R_PROFILE widget as a display fallback, but that field is id-valued (CrateDPLookup
    // valueExpr: 'Id', displayExpr: 'Name') and IMCRATES has no profile-code column of its own, so a
    // code string written there would be posted back as RProfile and fail Guid binding. Seeding the
    // profile's RowId is enough - the lookup resolves it to the code for display.

    /**
     * uWMD0063.SetParameters' seed branch - "if not RecordsExist then Insert; RECORDTYPE := 'P';
     * P_Profile := FR_Profile; Post". Nothing else is stamped, exactly as Delphi leaves it: no crate
     * number, no warehouse, no owner.
     *
     * The profile key arrives in the URL, so there is no lookup here.
     */
    const SeedProfileDefaultsCrate = (profileRowId) => {
        skipDataLoading = true;
        setformFields((prev) => ({
            ...prev,
            RowId: EMPTY_GUID,
            RecordType: RECORD_TYPE.PROFILE_DEFAULTS,
            RProfile: profileRowId,
        }));
        skipDataLoading = false;
    };

    const handlePrimaryFormLoad = useCallback((primaryRefs) => {
        primaryFormRefs.current = primaryRefs;

        const { isProfileDefaults: isProfileDefaultsRoute, profileRowId } = readProfileDefaults();
        if (!isProfileDefaultsRoute) return;

        // Seed only when creating. props.id is the create/edit discriminator - relying on RProfile
        // being absent on the edit route is fragile, because that route carries it too (so Back can
        // find its way home).
        if (!props.id && !hasSeededProfileDefaults.current && profileRowId) {
            SeedProfileDefaultsCrate(profileRowId);
            hasSeededProfileDefaults.current = true;
        }

        DisableProfileField();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.id]);


    return (
        <>
            <div>
                <div className="row dataEntryMainPage">
                    <div className="col-md-12 main-page">
                        <div id="accordion">

                            <LoadPanel
                                shadingColor="rgba(0,0,0,0.4)"
                                position={position}
                                onHiding={hideLoadPanel}
                                visible={loadPanelVisible}
                                showIndicator={true}
                                shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <form onSubmit={(e) => handleFormSubmit(e)}>
                                <Toolbar className="header">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2,
                                                    marginLeft: '12px'
                                                }}
                                            >
                                                Enter Crate Codes
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Save"
                                            useSubmitBehavior={true}
                                            type="default"
                                            className="accordianButton"
                                        />
                                    </Item>

                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={goBack} text="Back" />
                                    </Item>

                                </Toolbar>
                                <div className="AccordionItemBody">
                                    <TabPanel className="TabpanelContainer">
                                        <TabItem title="Primary">
                                            <PrimaryTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                handlePrimaryFormLoad={handlePrimaryFormLoad}
                                                handleFieldChange={handleFieldChange}
                                                Module={props.Module}
                                                isProfileDefaults={isProfileDefaults}
                                            />
                                        </TabItem>
                                        <TabItem title="Additional">
                                            <AdditionalTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                dialogVisible={dialogVisible}
                                                closeDialog={closeDialog}
                                                handleFieldChange={handleFieldChange}
                                            />
                                        </TabItem>
                                        <TabItem title="User Defined">
                                            <UserDefinedTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                dialogVisible={dialogVisible}
                                                closeDialog={closeDialog}
                                                Module={props.Module}
                                            />
                                        </TabItem>
                                        <TabItem title="Contents Detail" disabled={formFields.RowId === '00000000-0000-0000-0000-000000000000'} >
                                            <ContentsDetailTab  sourceId={formFields.RowId} Module={WM} />
                                        </TabItem>
                                    </TabPanel>
                                </div>
                                <div className="row">
                                    <ValidationSummary className="pl-3 pt-1" id="summary" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationDataEntryForm);